import type { DashboardSection } from '@/features/dashboard/api/schemas'
import { sectionTakes } from '@/features/dashboard/model/sections'
import { MarketChips } from './MarketChips'
import { MultiSelectFilter } from './MultiSelectFilter'
import { REGULATORY_FILTERS, useRegulatoryFilters } from './regulatoryFilters'
import { useSectionMarkets } from './useSectionMarkets'
import styles from './DeepDiveFilters.module.css'

/**
 * The filters of a deep dive, for the union of those its cards list: the
 * market chips (the dashboard's own selection), and a dropdown
 * for each of C-level, criticality and tag. Renders nothing when no card takes
 * any.
 */
export const DeepDiveFilters = ({ section }: { section: DashboardSection }) => {
  const { selection, toggle } = useRegulatoryFilters()

  const markets = useSectionMarkets(section)
  const regulatory = REGULATORY_FILTERS.filter(({ filter }) =>
    sectionTakes(section, filter)
  )
  if (!markets && regulatory.length === 0) return null

  return (
    <div className={styles.filters}>
      {markets && <MarketChips markets={markets} />}
      {regulatory.length > 0 && (
        <div className={styles.dropdowns} role='group' aria-label='Filter by'>
          {regulatory.map(({ param, label, options, searchable }) => (
            <MultiSelectFilter
              key={param}
              label={label}
              options={options}
              selected={selection[param]}
              searchable={searchable}
              onToggle={value => toggle(param, value)}
            />
          ))}
        </div>
      )}
    </div>
  )
}
